import type { ModulatorCsId, ModulatorHwId } from "~domain/devices/models/modulators/modulator-model.ts";
import type { PilotHwId } from "~domain/devices/models/pilot/pilot-model.ts";
import type { OperatorId } from "~domain/operators/models/operator-model.ts";
import type { SiteId } from "~domain/sites/models/site-model.ts";
import type { Brand } from "~utils/types/brand.ts";

export type SitePhotoId = Brand<string, "SitePhotoId">;

export enum ESitePhotoType {
  DELIVERY_POINT = "DELIVERY_POINT",
  CONTRACT = "CONTRACT",
  BEFORE_INSTALL_CLOSED = "BEFORE_INSTALL_CLOSED",
  BEFORE_INSTALL_OPENED = "BEFORE_INSTALL_OPENED",
  AFTER_INSTALL_CLOSED = "AFTER_INSTALL_CLOSED",
  AFTER_INSTALL_OPENED = "AFTER_INSTALL_OPENED",
  OTHER = "OTHER",
  RADIATORS = "RADIATORS",
  INSTALLATION_SHEET_VOLTA_PAP = "INSTALLATION_SHEET_VOLTA_PAP",
  ELECTRICAL_BOARD = "ELECTRICAL_BOARD",
  INSTALLATION_SHEET_VOLT_INSTALL = "INSTALLATION_SHEET_VOLT_INSTALL",
  CASKET = "CASKET",
  INSTALL_BEFORE_INSTALL = "INSTALL_BEFORE_INSTALL",
  INSTALL_AFTER_WIRING = "INSTALL_AFTER_WIRING",
  INSTALL_AFTER_REASSEMBLY = "INSTALL_AFTER_REASSEMBLY",
  UNINSTALL_BEFORE_UNINSTALL = "UNINSTALL_BEFORE_UNINSTALL",
  UNINSTALL_AFTER_REASSEMBLY = "UNINSTALL_AFTER_REASSEMBLY",
  BEFORE_WIRING = "BEFORE_WIRING",
  INITIAL_INVENTORY = "INITIAL_INVENTORY",
  NEW_IMPORT_INSTALLATION_SHEET = "NEW_IMPORT_INSTALLATION_SHEET",
  APPOINTMENT_COMMITMENT_FORM = "APPOINTMENT_COMMITMENT_FORM",
  ELECTRICITY_BILL = "ELECTRICITY_BILL",
  CEE_QUOTE = "CEE_QUOTE",
  PROGRAMMING_MODE_STICKER = "PROGRAMMING_MODE_STICKER",
  WIRE_MODE = "WIRE_MODE",
  NAME_PLATE = "NAME_PLATE",
  ELECTRICAL_BOARD_AND_HOUSING = "ELECTRICAL_BOARD_AND_HOUSING",
  RADIATORS_AND_TOWEL_DRYERS = "RADIATORS_AND_TOWEL_DRYERS",
  HOT_WATER_TANK = "HOT_WATER_TANK",
  UNKNOWN = "UNKNOWN",
}

export type SitePhotoPerson = {
  id: OperatorId;
  firstName?: string;
  lastName?: string;
};

export type SitePhotoModulator = {
  csId?: ModulatorCsId;
  hwId: ModulatorHwId;
};

export type SitePhotoPilot = {
  hwId: PilotHwId;
};

export type SitePhotoMeta = {
  deviceSerial?: string;
  person?: SitePhotoPerson;
  modulator?: SitePhotoModulator;
  pilot?: SitePhotoPilot;
};

export type SitePhoto = {
  id: SitePhotoId;
  siteId: SiteId;
  creationDateTime: Date;
  uploadDateTime: Date;
  url: string;
  filename: string;
  hash: string;
  type: ESitePhotoType;
  metadata: SitePhotoMeta;
};

export type SitePhotoBinary = SitePhoto & {
  binary: Blob;
};
